import React from 'react';
import { IconHotel } from '@americanexpress/dls-icons';

const AbandonHotelIcon = () => (
  <div
    data-testid="abandon-hotel-icon"
    className="margin-2-r dls-bright-blue dls-white-bg"
    style={{
      borderRadius: 100,
      paddingLeft: 8,
      paddingRight: 7,
      paddingTop: 6,
      paddingBottom: 3,
    }}
  >
    <IconHotel
      reactlytics={{
        disable: true,
      }}
      id="hotelIcon"
      size="md"
    />
  </div>
);

export default AbandonHotelIcon;
